export const drawerItemsMain = [
  {
    key: "Containers Management",
    title: "containersStatus",
    routes: [
      {
        nav: "ContainersManagement",
        routeName: "ContainersManagement",
        title: "containersStatus",
      },
    ],
  },
  {
    key: "Add Container",
    title: "addContainer",
    routes: [
      {
        nav: "ManageContainers",
        routeName: "ManageContainers",
        title: "addContainer",
      },
    ],
  },
  // {
  //   key: "Items Management",
  //   title: "itemsManagement",
  //   routes: [
  //     {
  //       nav: "ItemsManagement",
  //       routeName: "ItemsManagement",
  //       title: "itemsManagement",
  //     },
  //   ],
  // },
];
